import { lang, en_lang } from '../../lang';
//  ARABIC
let relType = lang.register.child.formLabels.relationType;
let childCom = lang.register.child.formLabels.childCommunicationType;
let servLoc = lang.register.child.formLabels.serviceLocation;
let childCities = lang.register.child.formLabels.cities;
let jobSpeciality = lang.register.job.formLabels.majors;

// ENGLISH
let en_relType = en_lang.register.child.formLabels.relationType;
let en_childCom = en_lang.register.child.formLabels.childCommunicationType;
let en_servLoc = en_lang.register.child.formLabels.serviceLocation;
let en_childCities = en_lang.register.child.formLabels.cities;
let en_jobSpeciality = en_lang.register.job.formLabels.majors;

export const relationType = [
    { value: 'father', label: `${relType.father}`, type: 'rel' },
    { value: 'mother', label: `${relType.mother}`, type: 'rel' },
    {
        value: 'grandparent',
        label: `${relType.grandparent}`,
        type: 'rel',
    },
    { value: 'sibling', label: `${relType.sibling}`, type: 'rel' },
    { value: 'maternal', label: `${relType.maternal}`, type: 'rel' },
    { value: 'paternal', label: `${relType.paternal}`, type: 'rel' },
    { value: 'other', label: `${relType.other}`, type: 'rel' },
];

export const en_relationType = [
    { value: 'father', label: `${en_relType.father}`, type: 'rel' },
    { value: 'mother', label: `${en_relType.mother}`, type: 'rel' },
    {
        value: 'grandparent',
        label: `${en_relType.grandparent}`,
        type: 'rel',
    },
    { value: 'sibling', label: `${en_relType.sibling}`, type: 'rel' },
    { value: 'maternal', label: `${en_relType.maternal}`, type: 'rel' },
    { value: 'paternal', label: `${en_relType.paternal}`, type: 'rel' },
    { value: 'other', label: `${en_relType.other}`, type: 'rel' },
];


export const serviceOptions = [
    { value: 'home', label: `${servLoc.home}`, type: 'service' },
    { value: 'rehab', label: `${servLoc.rehab}`, type: 'service' },
    { value: 'daycare', label: `${servLoc.daycare}`, type: 'service' },
    {
        value: 'govHospital',
        label: `${servLoc.govHospital}`,
        type: 'service',
    },
    {
        value: 'privateHospital',
        label: `${servLoc.privateHospital}`,
        type: 'service',
    },
];

export const en_serviceOptions = [
    { value: 'home', label: `${en_servLoc.home}`, type: 'service' },
    { value: 'rehab', label: `${en_servLoc.rehab}`, type: 'service' },
    { value: 'daycare', label: `${en_servLoc.daycare}`, type: 'service' },
    {
        value: 'govHospital',
        label: `${en_servLoc.govHospital}`,
        type: 'service',
    },
    {
        value: 'privateHospital',
        label: `${en_servLoc.privateHospital}`,
        type: 'service',
    },
];

export const comOptns = [
    { value: 'non_verbal', label: `${childCom.nonVerbal}`, type: 'com' },
    { value: 'signs', label: `${childCom.sign}`, type: 'com' },
    {
        value: 'single',
        label: `${childCom.singleWords}`,
        type: 'com',
    },
    {
        value: 'simple',
        label: `${childCom.singleSentences}`,
        type: 'com',
    },
    {
        value: 'long',
        label: `${childCom.longSentences}`,
        type: 'com',
    },
    { value: 'aac', label: `${childCom.AAC}`, type: 'com' },
];

export const en_comOptns = [
    { value: 'non_verbal', label: `${en_childCom.nonVerbal}`, type: 'com' },
    { value: 'signs', label: `${en_childCom.sign}`, type: 'com' },
    {
        value: 'single',
        label: `${en_childCom.singleWords}`,
        type: 'com',
    },
    {
        value: 'simple',
        label: `${en_childCom.singleSentences}`,
        type: 'com',
    },
    {
        value: 'long',
        label: `${en_childCom.longSentences}`,
        type: 'com',
    },
    { value: 'aac', label: `${en_childCom.AAC}`, type: 'com' },
];

export const majorOptns = [
    { value: 'slp', label: `${jobSpeciality.slp}`, type: 'major' },
    { value: 'specialEd', label: `${jobSpeciality.specialEd}`, type: 'major' },
    {
        value: 'occTherapy',
        label: `${jobSpeciality.occTherapy}`,
        type: 'major',
    },
    {
        value: 'clinicalPsych',
        label: `${jobSpeciality.clinicalPsych}`,
        type: 'major',
    },
    {
        value: 'socialScience',
        label: `${jobSpeciality.socialScience}`,
        type: 'major',
    },
    { value: 'devPed', label: `${jobSpeciality.devPed}`, type: 'major' },
    { value: 'it', label: `${jobSpeciality.it}`, type: 'major' },
    {
        value: 'businessMgmt',
        label: `${jobSpeciality.businessMgmt}`,
        type: 'major',
    },
    { value: 'finance', label: `${jobSpeciality.finance}`, type: 'major' },
    { value: 'hr', label: `${jobSpeciality.hr}`, type: 'major' },
    {
        value: 'procurement',
        label: `${jobSpeciality.procurement}`,
        type: 'major',
    },
    { value: 'marketing', label: `${jobSpeciality.marketing}`, type: 'major' },
    { value: 'pr', label: `${jobSpeciality.pr}`, type: 'major' },
    { value: 'support', label: `${jobSpeciality.support}`, type: 'major' },
    { value: 'other', label: `${jobSpeciality.other}`, type: 'major' },
];

export const en_majorOptns = [
    { value: 'slp', label: `${en_jobSpeciality.slp}`, type: 'major' },
    { value: 'specialEd', label: `${en_jobSpeciality.specialEd}`, type: 'major' },
    {
        value: 'occTherapy',
        label: `${en_jobSpeciality.occTherapy}`,
        type: 'major',
    },
    {
        value: 'clinicalPsych',
        label: `${en_jobSpeciality.clinicalPsych}`,
        type: 'major',
    },
    {
        value: 'socialScience',
        label: `${en_jobSpeciality.socialScience}`,
        type: 'major',
    },
    { value: 'devPed', label: `${en_jobSpeciality.devPed}`, type: 'major' },
    { value: 'it', label: `${en_jobSpeciality.it}`, type: 'major' },
    {
        value: 'businessMgmt',
        label: `${en_jobSpeciality.businessMgmt}`,
        type: 'major',
    },
    { value: 'finance', label: `${en_jobSpeciality.finance}`, type: 'major' },
    { value: 'hr', label: `${en_jobSpeciality.hr}`, type: 'major' },
    {
        value: 'procurement',
        label: `${en_jobSpeciality.procurement}`,
        type: 'major',
    },
    { value: 'marketing', label: `${en_jobSpeciality.marketing}`, type: 'major' },
    { value: 'pr', label: `${en_jobSpeciality.pr}`, type: 'major' },
    { value: 'support', label: `${en_jobSpeciality.support}`, type: 'major' },
    { value: 'other', label: `${en_jobSpeciality.other}`, type: 'major' },
];


export const schoolCityOptns = [
    { value: 'riyadh', label: `${childCities.riyadh}`, type: 'schoolCity' },
    { value: 'jeddah', label: `${childCities.jeddah}`, type: 'schoolCity' },
    { value: 'makkah', label: `${childCities.makkah}`, type: 'schoolCity' },
    { value: 'madinah', label: `${childCities.madinah}`, type: 'schoolCity' },
    { value: 'haiel', label: `${childCities.haiel}`, type: 'schoolCity' },
    { value: 'qassim', label: `${childCities.qassim}`, type: 'schoolCity' },
    { value: 'baha', label: `${childCities.baha}`, type: 'schoolCity' },
    { value: 'eastRegion', label: `${childCities.east}`, type: 'schoolCity' },
    { value: 'northRegion', label: `${childCities.north}`, type: 'schoolCity' },
    { value: 'najran', label: `${childCities.najran}`, type: 'schoolCity' },
    { value: 'jouf', label: `${childCities.jouf}`, type: 'schoolCity' },
    { value: 'aseer', label: `${childCities.aseer}`, type: 'schoolCity' },
    { value: 'jazan', label: `${childCities.jazan}`, type: 'schoolCity' },
    { value: 'outOfSaudi', label: `${childCities.out}`, type: 'schoolCity' },
];

export const en_schoolCityOptns = [
    { value: 'riyadh', label: `${en_childCities.riyadh}`, type: 'schoolCity' },
    { value: 'jeddah', label: `${en_childCities.jeddah}`, type: 'schoolCity' },
    { value: 'makkah', label: `${en_childCities.makkah}`, type: 'schoolCity' },
    { value: 'madinah', label: `${en_childCities.madinah}`, type: 'schoolCity' },
    { value: 'haiel', label: `${en_childCities.haiel}`, type: 'schoolCity' },
    { value: 'qassim', label: `${en_childCities.qassim}`, type: 'schoolCity' },
    { value: 'baha', label: `${en_childCities.baha}`, type: 'schoolCity' },
    { value: 'eastRegion', label: `${en_childCities.east}`, type: 'schoolCity' },
    { value: 'northRegion', label: `${en_childCities.north}`, type: 'schoolCity' },
    { value: 'najran', label: `${en_childCities.najran}`, type: 'schoolCity' },
    { value: 'jouf', label: `${en_childCities.jouf}`, type: 'schoolCity' },
    { value: 'aseer', label: `${en_childCities.aseer}`, type: 'schoolCity' },
    { value: 'jazan', label: `${en_childCities.jazan}`, type: 'schoolCity' },
    { value: 'outOfSaudi', label: `${en_childCities.out}`, type: 'schoolCity' },
];


export const rehabCityOptns = [
    { value: 'riyadh', label: `${childCities.riyadh}`, type: 'rehabCity' },
    { value: 'jeddah', label: `${childCities.jeddah}`, type: 'rehabCity' },
    { value: 'makkah', label: `${childCities.makkah}`, type: 'rehabCity' },
    { value: 'madinah', label: `${childCities.madinah}`, type: 'rehabCity' },
    { value: 'haiel', label: `${childCities.haiel}`, type: 'rehabCity' },
    { value: 'qassim', label: `${childCities.qassim}`, type: 'rehabCity' },
    { value: 'baha', label: `${childCities.baha}`, type: 'rehabCity' },
    { value: 'eastRegion', label: `${childCities.east}`, type: 'rehabCity' },
    { value: 'northRegion', label: `${childCities.north}`, type: 'rehabCity' },
    { value: 'najran', label: `${childCities.najran}`, type: 'rehabCity' },
    { value: 'jouf', label: `${childCities.jouf}`, type: 'rehabCity' },
    { value: 'aseer', label: `${childCities.aseer}`, type: 'rehabCity' },
    { value: 'jazan', label: `${childCities.jazan}`, type: 'rehabCity' },
    { value: 'outOfSaudi', label: `${childCities.out}`, type: 'rehabCity' },
];

export const en_rehabCityOptns = [
    { value: 'riyadh', label: `${en_childCities.riyadh}`, type: 'rehabCity' },
    { value: 'jeddah', label: `${en_childCities.jeddah}`, type: 'rehabCity' },
    { value: 'makkah', label: `${en_childCities.makkah}`, type: 'rehabCity' },
    { value: 'madinah', label: `${en_childCities.madinah}`, type: 'rehabCity' },
    { value: 'haiel', label: `${en_childCities.haiel}`, type: 'rehabCity' },
    { value: 'qassim', label: `${en_childCities.qassim}`, type: 'rehabCity' },
    { value: 'baha', label: `${en_childCities.baha}`, type: 'rehabCity' },
    { value: 'eastRegion', label: `${en_childCities.east}`, type: 'rehabCity' },
    { value: 'northRegion', label: `${en_childCities.north}`, type: 'rehabCity' },
    { value: 'najran', label: `${en_childCities.najran}`, type: 'rehabCity' },
    { value: 'jouf', label: `${en_childCities.jouf}`, type: 'rehabCity' },
    { value: 'aseer', label: `${en_childCities.aseer}`, type: 'rehabCity' },
    { value: 'jazan', label: `${en_childCities.jazan}`, type: 'rehabCity' },
    { value: 'outOfSaudi', label: `${en_childCities.out}`, type: 'rehabCity' },
];

export const colourStyles = {
    control: (styles) => ({ ...styles, backgroundColor: 'white' }),
    option: (styles, { isDisabled, isFocused, isSelected }) => {
        return {
            ...styles,
            backgroundColor: isDisabled
                ? '#999'
                : isSelected
                ? '#7d56ff'
                : isFocused
                ? 'rgba(168, 151, 236, 0.2)'
                : null,
            color: isDisabled ? '#ccc' : isSelected ? 'white' : 'black',
            cursor: isDisabled ? 'not-allowed' : 'default',

            ':active': {
                ...styles[':active'],
                backgroundColor:
                    !isDisabled && (isSelected ? '#7d56ff' : '#7d56ff'),
            },
        };
    },
    input: (styles) => ({ ...styles }),
    placeholder: (styles) => ({ ...styles }),
    singleValue: (styles, { data }) => ({ ...styles }),
};

export const dangerStyles = {
    control: (styles) => ({
        ...styles,
        backgroundColor: 'white',
        height: '45px',
        marginTop: '0.75em',
        border: '1px solid red',
    }),
    option: (styles, { isDisabled, isFocused, isSelected }) => {
        return {
            ...styles,
            backgroundColor: isDisabled
                ? '#999'
                : isSelected
                ? '#7d56ff'
                : isFocused
                ? 'rgba(168, 151, 236, 0.2)'
                : null,
            color: isDisabled ? '#ccc' : isSelected ? 'white' : 'black',
            cursor: isDisabled ? 'not-allowed' : 'default',

            ':active': {
                ...styles[':active'],
                backgroundColor:
                    !isDisabled && (isSelected ? '#7d56ff' : '#7d56ff'),
            },
        };
    },
    input: (styles) => ({ ...styles }),
    placeholder: (styles) => ({ ...styles, color: 'red' }),
    singleValue: (styles, { data }) => ({ ...styles }),
};

export const modalStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};
